import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

function ContactSection() {
  const form = useRef();
  const [status, setStatus] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_f1sh5pd",
        "template_csb6z2v",
        form.current,
        "6wSJlxr2YtGvthAtJ"
      )
      .then(() => {
        setStatus("success");
        form.current.reset();
      })
      .catch((error) => {
        console.error("Email send failed:", error);
        setStatus("error");
      });
  };

  return (
    <section className="contacts section">
      <div className="container">
        <header className="section-header">
          <h2 className="section-title">
            Get <span className="text-primary">in touch</span>
          </h2>
          <strong className="fade-title-right">contacts</strong>
        </header>

        <div className="section-content">
          <div className="row-base row">
            {/* Address / phones */}
            <div className="col-address col-base col-md-4">
              +60 (19) 578-0801
              <br />
              +60 (7) 597-0720
              <br />
              sales@xinchuan.site
              <br />
              No 987, Jalan Idaman 2/15/5,
              <br />
              Taman Desa Idaman,
              <br />
              81400 Senai, Johor Darul Ta'Zim
            </div>

            {/* Form (EmailJS) */}
            <div className="col-base col-md-8">
              <form ref={form} onSubmit={sendEmail} className="js-emailjs-form">
                <div className="row-field row">
                  <div className="col-field col-sm-6 col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        placeholder="Name"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        required
                        placeholder="Email *"
                      />
                    </div>
                  </div>

                  <div className="col-field col-sm-6 col-md-4">
                    <div className="form-group">
                      <input
                        type="tel"
                        className="form-control"
                        name="phone"
                        placeholder="Phone"
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="company"
                        placeholder="Company"
                      />
                    </div>
                  </div>

                  <div className="col-field col-sm-12 col-md-4">
                    <div className="form-group">
                      <textarea
                        className="form-control"
                        name="message"
                        placeholder="Message"
                        required
                      />
                    </div>
                  </div>

                  <div className="col-message col-field col-sm-12">
                    {status === "success" && (
                      <div className="alert alert-success">
                        <i className="fa fa-check text-primary"></i> Thank you! Your message is successfully sent.
                      </div>
                    )}
                    {status === "error" && (
                      <div className="alert alert-danger">
                        <i className="fa fa-times text-danger"></i> Oops! Something went wrong. Please try again.
                      </div>
                    )}
                  </div>
                </div>
                <div className="form-submit text-right">
                  <button type="submit" className="btn btn-shadow-2 wow swing">
                    Send <i className="icon-next" />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
